import normalizeAdminServiceBillingFromApi from '@/hooks/admin/services/helpers/normalizeAdminServiceBillingFromApi';
import type { AdminServiceBillingPlan } from '@/hooks/admin/services/types';
import type { NormalizeOrganizationServiceBillingFromApiParams } from '../types';
import throwUnsupportedOrganizationService from './throwUnsupportedOrganizationService';

const normalizeOrganizationServiceBillingFromApi = ({
    billing,
}: NormalizeOrganizationServiceBillingFromApiParams): AdminServiceBillingPlan => {
    try {
        return normalizeAdminServiceBillingFromApi({ billing });
    } catch {
        return throwUnsupportedOrganizationService({});
    }
};

export default normalizeOrganizationServiceBillingFromApi;
